import { render, staticRenderFns } from "./SearchTabProfileForm.vue?vue&type=template&id=c21a1f72&scoped=true&"
import script from "./SearchTabProfileForm.vue?vue&type=script&lang=js&"
export * from "./SearchTabProfileForm.vue?vue&type=script&lang=js&"
import style0 from "./SearchTabProfileForm.vue?vue&type=style&index=0&id=c21a1f72&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c21a1f72",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCol,VRow,VTextField})
